"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validRecipeImportUrl = exports.validRecipe = exports.MAX_NUMBER_OF_INGREDIENTS = exports.RECIPE_INGREDIENT_HEADER_MAX_LENGTH = exports.RECIPE_INGREDIENT_DETAIL_MAX_LENGTH = exports.RECIPE_INGREDIENT_UNIT_MAX_LENGTH = exports.RECIPE_INGREDIENT_AMOUNT_MAX_LENGTH = exports.RECIPE_INGREDIENT_NAME_MAX_LENGTH = exports.RECIPE_INSTRUCTIONS_MAX_LENGTH = exports.RECIPE_DESCRIPTION_MAX_LENGTH = exports.RECIPE_SOURCE_URL_MAX_LENGTH = exports.RECIPE_SOURCE_MAX_LENGTH = exports.RECIPE_SERVINGS_MAX_LENGTH = exports.RECIPE_PICTURE_URL_MAX_LENGTH = exports.RECIPE_NAME_MAX_LENGTH = void 0;
const errorMessageGenerator_1 = require("../utils/errorMessageGenerator");
const instance_1 = __importDefault(require("./instance"));
exports.RECIPE_NAME_MAX_LENGTH = 255;
exports.RECIPE_PICTURE_URL_MAX_LENGTH = 500;
exports.RECIPE_SERVINGS_MAX_LENGTH = 255;
exports.RECIPE_SOURCE_MAX_LENGTH = 255;
exports.RECIPE_SOURCE_URL_MAX_LENGTH = 2000;
exports.RECIPE_DESCRIPTION_MAX_LENGTH = 5000;
exports.RECIPE_INSTRUCTIONS_MAX_LENGTH = 20000;
exports.RECIPE_INGREDIENT_NAME_MAX_LENGTH = 1000;
exports.RECIPE_INGREDIENT_AMOUNT_MAX_LENGTH = 1000;
exports.RECIPE_INGREDIENT_UNIT_MAX_LENGTH = 1000;
exports.RECIPE_INGREDIENT_DETAIL_MAX_LENGTH = 1000;
exports.RECIPE_INGREDIENT_HEADER_MAX_LENGTH = 1000;
exports.MAX_NUMBER_OF_INGREDIENTS = 500;
exports.validRecipe = instance_1.default.object().shape({
    name: instance_1.default
        .string()
        .max(exports.RECIPE_NAME_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.RECIPE_NAME_MAX_LENGTH))
        .required(errorMessageGenerator_1.requiredError),
    servings: instance_1.default
        .string()
        .max(exports.RECIPE_SERVINGS_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.RECIPE_SERVINGS_MAX_LENGTH))
        .nullable(true),
    source: instance_1.default
        .string()
        .max(exports.RECIPE_SOURCE_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.RECIPE_SOURCE_MAX_LENGTH))
        .nullable(true),
    sourceUrl: instance_1.default
        .string()
        .url("invalid url")
        .max(exports.RECIPE_SOURCE_URL_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.RECIPE_SOURCE_URL_MAX_LENGTH))
        .nullable(true),
    description: instance_1.default
        .string()
        .max(exports.RECIPE_DESCRIPTION_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(exports.RECIPE_DESCRIPTION_MAX_LENGTH))
        .nullable(true),
    times: instance_1.default
        .array()
        .of(instance_1.default.object().shape({
        type: instance_1.default.string().required(errorMessageGenerator_1.requiredError),
        hr: instance_1.default
            .number()
            .transform(x => parseInt(x, 10))
            .typeError("numbers only")
            .integer("numbers only")
            .max(10000, "Max is 10000"),
        min: instance_1.default
            .number()
            .transform(x => parseInt(x, 10))
            .typeError("numbers only")
            .integer("numbers only")
            .max(10000, "max is 10000"),
    }))
        .max(3),
});
exports.validRecipeImportUrl = instance_1.default.object().shape({
    name: instance_1.default
        .string()
        .required("required")
        .transform(x => x && x.trim())
        .url("invalid url")
        .test("is-pepperplate", "Individual recipes cannot be imported from pepperplate, but if you send me an email at ben@mysaffronapp.com I can help you bulk import all your pepperplate recipes.", value => !!(value && !value.includes("pepperplate.com"))),
});
//# sourceMappingURL=recipe.js.map